module.exports = __webpack_public_path__ + "cci-wordmark-dd7d00aea301757f5a76d53e6af7128b.webp";